export default __webpack_public_path__ + "static/media/requisitos.41119f06.png";